import { type PropsWithChildren } from "react";

export const Header = ({ children }: Readonly<PropsWithChildren>) => (
  <header
    data-testid="circle-ai-shell-conversation-panel-header"
    className="shrink-0"
  >
    {children}
  </header>
);

Header.displayName = "CircleAIAppShell.Layout.ConversationPanel.Header";
